export default __webpack_public_path__ + "media/svgs/discount_24-4aaf9c97.svg";